import React from 'react';

import {useStore} from 'effector-react';

import {codeTracingState$} from 'models/products/detail';

import {Container, Wrapper} from './styled';
import {TraceGraph} from './TraceGraph';

export const Tracking = () => {
    const {data, isLoading, error} = useStore(codeTracingState$);

    return (
        <Wrapper>
            <Container status={isLoading ? 'loading' : error != null ? 'error' : 'default'}>
                <TraceGraph data={data} />
            </Container>
        </Wrapper>
    );
};
